import { Inject, Injectable } from '@angular/core';
import { InteractivityChecker } from '@angular/cdk/a11y';

@Injectable({ providedIn: 'root' })
export class InteractivityService {

  constructor(@Inject(InteractivityChecker) private interactivityChecker: InteractivityChecker) {
  }

  getFirstTabbableElement(root: HTMLElement): HTMLElement | null {
    if (this.interactivityChecker.isFocusable(root) && this.interactivityChecker.isTabbable(root)) {
      return root;
    }
    const children = root.children;

    for (let i = 0; i < children.length; i++) {
      const tabbableChild = children[i].nodeType === Node.ELEMENT_NODE ?
        this.getFirstTabbableElement(children[i] as HTMLElement) : undefined;
      if (tabbableChild !== undefined) {
        return tabbableChild;
      }
    }
    return undefined;
  }

}
